import router from '../router/index'

export const CommercialState = {
  namespaced: true,
  state: {

    activeCart : []

  },

  mutations: {

    AddItemToCart(state, item)
    {
        state.activeCart.push(item);
    },
    RemoveItemFromCart(state, index)
    {
        state.activeCart.splice(index,1);
    },
    AdjustQuantityForItem(state, payload) //payload.itemIndex - payload.quantity
    {
        state.activeCart[payload.itemIndex].quantity = payload.quantity;
    },
    ClearCart(state)
    {
        state.activeCart = [];
    }
  },
  actions: {
   
  },
  getters: {

  }
}